import { useEffect, useMemo, useState } from 'react'

import { Button } from '@/components/button/button'
import { useRoomConfigurationQueryQuery } from '@/features/url-handling'
import { cn } from '@/libs/tw'
import { useCartStore } from '@/stores/cart-store/cartStore'
import { useStepStore } from '@/stores/step-store/stepStore'
import { translate } from '@/utils/translator'

import { RoomConfiguration } from './roomConfiguration'

const MAX_ROOM_COUNT = 9

export const RoomConfigurationContent = () => {
	useRoomConfigurationQueryQuery()
	const location = useCartStore.use.location()

	const setNextStep = useStepStore.use.setNextStep()
	const roomConfigurations = useCartStore.use.roomConfigurations()
	const addRoomConfiguration = useCartStore.use.addRoomConfiguration()
	const updateRoomConfiguration = useCartStore.use.updateRoomConfiguration()
	const removeRoomConfiguration = useCartStore.use.removeRoomConfiguration()

	const isAllRoomsValid = roomConfigurations.every((room) => room.isValid)

	return (
		<div className={cn('flex flex-col gap-24')}>
			<div
				className={cn(
					'flex flex-col gap-24',
					'md:grid md:grid-cols-2 md:items-start lg:grid-cols-3 xl:grid-cols-4'
				)}
			>
				{roomConfigurations.map((roomConf, index) => (
					<RoomConfiguration
						key={roomConf.id}
						roomIndex={index + 1}
						availableTypes={[]}
						onDelete={removeRoomConfiguration}
						onUpdate={updateRoomConfiguration}
						roomConf={roomConf}
					/>
				))}
				<Button
					onClick={() => addRoomConfiguration()}
					style="transparent"
					className="hidden md:block"
					disabled={roomConfigurations.length >= MAX_ROOM_COUNT}
				>
					{translate('room-config-add-room')}
				</Button>
			</div>
			<div
				className={cn(
					'mt-8 flex flex-col border-t border-naturel pt-24',
					'gap-24  md:mt-0 md:grid md:grid-cols-2 md:border-none lg:grid-cols-3 xl:grid-cols-4'
				)}
			>
				<Button
					onClick={() => addRoomConfiguration()}
					style="transparent"
					className="md:hidden"
					disabled={roomConfigurations.length >= MAX_ROOM_COUNT}
				>
					{translate('room-config-add-room')}
				</Button>

				{roomConfigurations.length !== 0 && (
					<Button
						className={cn(
							'w-full',
							'bg-roomConfiguration-button text-roomConfiguration-buttonText md:col-start-2 lg:col-start-3 xl:col-start-4'
						)}
						onClick={() => setNextStep()}
						style="naturel"
						disabled={!isAllRoomsValid}
					>
						{translate('room-config-submit-configuration')}
					</Button>
				)}
			</div>
		</div>
	)
}
